import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Card } from "react-bootstrap";
import { useQuery } from "@apollo/client";

import ActionForm from "../../../components/profile/ActionForm";
import ProfileBanner from "../../../components/profile/Banner";
import ActivityLog from "../../../components/profile/ActivityLog";
import QUERY from "../../../utils/service/query";

const UserProfile: React.FC = () => {
	const { userId } = useParams();
	const [page, setPage] = useState(1);

	const { data } = useQuery(QUERY.USERS.GET_USER, {
		variables: { id: userId },
	});
	const res = useQuery(QUERY.USERS.GET_ACTIVITY_LOG, {
		variables: { userId: userId, page: page },
	});

	return (
		<>
			<ProfileBanner
				profileImage={data?.getOneUser?.profileImage}
				fullName={
					(data?.getOneUser?.userProfile?.firstName ?? "") +
					" " +
					(data?.getOneUser?.userProfile?.lastName ?? "")
				}
				userName={data?.getOneUser?.displayName ?? ""}
				userType={data?.getOneUser?.userType ?? ""}
				email={data?.getOneUser?.email ?? ""}
				phone={data?.getOneUser?.userProfile?.phoneNumber ?? ""}
				warnings={data?.getOneUser?.warningsCount ?? 0}
				collabers={data?.getOneUser?.collabersCount ?? 0}
				clipsShared={data?.getOneUser?.clipsCount ?? 0}
			/>
			<Card className="mb-3">
				<Card.Header>
					<h5>Take Action</h5>
				</Card.Header>
				<Card.Body className="bg-light">
					<ActionForm userId={userId ?? ""} status={data?.getOneUser?.status} />
				</Card.Body>
			</Card>
			<ActivityLog
				activities={res?.data?.activityLogsList?.list || []}
				totalCount={res?.data?.activityLogsList?.totalCount || 1}
				currentPage={res?.data?.activityLogsList?.page || 1}
				pageSize={res?.data?.activityLogsList?.limit || 25}
				setPage={setPage}
			/>
		</>
	);
};

export default UserProfile;
